import {Component} from 'react';
import {Button, Drawer, Select, Spin} from 'antd';
import {handleDownloadTaskList, getDownloadSignUrl} from '@/api/download';
import Toast from '@/components/Toast';
import {CloseOutlined, InfoCircleOutlined} from '@ant-design/icons';
import {cloneDeep} from 'lodash';
// @ts-ignore
import success from '@/assets/images/download/success.png';
// @ts-ignore
import fail from '@/assets/images/download/fail.png';
// @ts-ignore
import loading from '@/assets/images/download/loading.png';
// @ts-ignore
import default_empty from '@/assets/images/download/default_empty.png';
// @ts-ignore
import style from './style.module.less';
import moment from 'moment';

type RequestResultType = {
    success?: boolean;
    msg?: string;
    code?: string;
};
type TaskItemType = {
    id?: string;
    task_name_type?: string;
    task_state?: 'process' | 'fail' | 'complete';
    complete_time?: number;
    obs_object_key?: string;
    download_bucket_name?: string;
    down_file_name?: string;
    module_type?: string;
    module_name?: string;
    create_time?: number;
}
type TaskListType = TaskItemType[];
type OptionItemType = {
    label?: string;
    value?: string;
};

interface Props {
    show: boolean;
    onClose?: () => void;
}

interface TaskListRequestResult extends RequestResultType {
    data: TaskListType;
}

interface State {
    show?: boolean
    taskList: TaskListType;
    options: OptionItemType[];
    data: TaskListType;
    currentSelectValue: string;
}

class DownloadDrawer extends Component<Props, State> {
    state: State = {
        show: this.props.show,
        taskList: [],
        options: [],
        data: [],
        currentSelectValue: '-1'
    };
    timer: number = 0;

    static getDerivedStateFromProps(nextProps: Props, prevState: State) {
        if (nextProps.show && !prevState.show) {
            prevState.show = nextProps.show;
            return prevState;
        } else if (!nextProps.show) {
            prevState.show = false;
            prevState.currentSelectValue = '-1';
            return prevState;
        }
        return null;
    }

    initSetTimeOut() {
        return window.setTimeout(() => {
            this.fetchList();
        }, 5000);
    }

    fetchList() {
        const result: Promise<TaskListRequestResult> = handleDownloadTaskList();
        result.then(res => {
            let {success, data, msg} = res;
            if (success && data?.length) {
                let taskList: TaskListType = cloneDeep(data),
                    optionsKey: Set<string> = new Set();
                const options: OptionItemType[] = [{value: '-1', label: '全部模块'}];
                data.map(item => {
                    if (!optionsKey.has(item.module_type as string)) {
                        optionsKey.add(item.module_type as string);
                        options.push({
                            label: item.module_name,
                            value: item.module_type
                        });
                    }
                });

                if (this.state.currentSelectValue) {
                    const value = this.state.currentSelectValue;
                    if (value !== '-1') {
                        taskList = taskList.filter(item => {
                            return item.module_type === value;
                        });
                    }
                }
                this.setState({taskList, data, options});
            } else {
                if (!success) Toast.info(msg || '服务请求发生错误');
                const options: OptionItemType[] = [{value: '-1', label: '全部模块'}];
                this.setState({taskList: [], data: [], options});
            }
            this.timer = this.initSetTimeOut();
        });
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>) {
        if (prevState.show !== prevProps.show && !prevProps.show) {
            this.fetchList();
        }
    }

    componentWillUnmount() {
        window.clearTimeout(this.timer);
    }

    onClose() {
        if (this.props?.onClose) {
            this.props.onClose();
            window.clearTimeout(this.timer);
        }
    }

    get title() {
        return (
            <div className={style['header-title']}>
                <h1>我的下载任务</h1>
                <CloseOutlined className={style['header-close']} onClick={this.onClose.bind(this)}/>
            </div>
        );
    }

    onChangeSelect(value: string) {
        this.setState({currentSelectValue: value}, () => {
            let taskList: TaskListType = cloneDeep(this.state.data);
            if (value !== '-1') {
                taskList = taskList.filter(item => {
                    return item.module_type === value;
                });
                this.setState({taskList});
            } else {
                this.setState({taskList});
            }
        });
    }

    taskListContent() {
        return <div className={'download-drawer'}>
            <div className={style['download-drawer-title']}>
                <Select style={{width: 120}} placeholder="全部模块" value={this.state.currentSelectValue}
                        onChange={this.onChangeSelect.bind(this)}
                        options={this.state.options}/>
                <div className={style['download-drawer-title-span']}>
                    <InfoCircleOutlined/>
                    <span>系统只保留最新15天内的下载记录</span>
                </div>
            </div>
            <div className={style['download-drawer-content']}
                 style={this.state.taskList?.length === 0 ? {justifyContent: 'center'} : {}}>
                {this.state.taskList?.length ?
                    this.state.taskList?.map(item => {
                        return <div key={item.id}
                                    className={style['download-drawer-content-item']}>
                            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                {
                                    item.task_state === 'process' ?
                                        <div className={style['download-drawer-content-item-icon']}>
                                            <img width={28} height={28} src={loading} alt={''}/>
                                            <Spin spinning={true} style={{position: 'absolute', top: 4, left: 4}}/>
                                        </div> : item.task_state === 'complete' ?
                                            <div className={style['download-drawer-content-item-icon']}>
                                                <img width={28} height={28} src={success} alt={''}/>
                                            </div> : item.task_state === 'fail' ?
                                                <div className={style['download-drawer-content-item-icon']}>
                                                    <img width={28} height={28} src={fail} alt={''}/>
                                                </div> : null
                                }
                                <div className={style['download-drawer-content-item-title']}>
                                <span
                                    className={style['download-drawer-content-item-name']}>{item.down_file_name}</span>
                                    <span
                                        className={style['download-drawer-content-item-time']}>导出时间：{item.create_time ? moment(item.create_time).format('YYYY-MM-DD HH:mm:ss') : '-'}</span>
                                </div>
                            </div>
                            {
                                item.task_state === 'process' ?
                                    <Button disabled={true}>下载文件</Button> : item.task_state === 'complete' ?
                                        <Button type={'primary'} onClick={() => this.downloadFile(item)}>下载文件</Button> :
                                        <span className={style['handle-error-tips']}>数据处理失败</span>
                            }

                        </div>;
                    }) : <div className={style['download-empty-content']}>
                        <img src={default_empty} alt={''}/>
                        <span>暂无15天内的下载记录</span>
                    </div>
                }
            </div>
        </div>;
    }

    async downloadFile(ite: TaskItemType) {
        try {
            const {
                success,
                data
            } = await getDownloadSignUrl(ite.download_bucket_name as string, ite.obs_object_key as string);
            if (success) {
                const ele = document.createElement('a');
                ele.setAttribute('download', ite.down_file_name as string);
                ele.setAttribute('target', '_blank');
                ele.href = data as string;
                ele.click();
                ele.remove();
            }
        } catch (e) {
            Toast.info('下载失败');
        }
    }

    render() {
        return <Drawer width={520} destroyOnClose={true} closable={false} title={this.title} footer={null}
                       open={this.state.show}>{
            this.taskListContent()
        }</Drawer>;
    }

}

export default DownloadDrawer;